import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { FormControl } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { Observable } from 'rxjs';
import { startWith, debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';

import { Order } from '../../models/order.model';
import { OrderService } from '../../services/order.service';

@Component({
  selector: 'app-search-edict',
  templateUrl: './search-edict.component.html',
  styleUrls: ['./search-edict.component.scss']
})
export class SearchEdictComponent {
  autocompleteCtrl: FormControl;
  filteredOrders: Observable<Order[]>;
  constructor(private orderService: OrderService,
    private router: Router
  ) {
    this.autocompleteCtrl = new FormControl();
    this.filteredOrders = this.autocompleteCtrl.valueChanges
      .pipe(
        startWith(null),
        debounceTime(300),
        distinctUntilChanged(),
        switchMap(val => {
          if (val) {
            return orderService.autocompleteSearch(val);
          } else {
            return [];
          }
        })
      );
  }

  itemSelected(evt: MatAutocompleteSelectedEvent) {
    this.router.navigateByUrl(`buscar/${evt.option.value}`);
  }
}
